import { Suspense, useEffect, useMemo, useState } from 'react';

import { usePlacementHomeShowcases } from '~/domains/mmp/queries';
import { useBusinessIdStore } from '~/store/global/useBusinessIdStore';

import type { HomeShowcaseListType } from './helper';
import { SelectedShowcase } from './SelectedShowcase';
import { VerticalShowcaseList } from './VerticalShowcaseList';

export function HomeShowcaseList() {
  const { businessId } = useBusinessIdStore();
  const { data } = usePlacementHomeShowcases(businessId);

  const [selectedShowcase, setSelectedShowcase] = useState<
    HomeShowcaseListType[number] | undefined
  >(undefined);

  const list = useMemo(() => data?.items || [], [data]);

  useEffect(() => {
    if (list.length) {
      setSelectedShowcase(list[0]);
    }
  }, [list]);

  if (list.length === 0) {
    return null;
  }

  return (
    <section className="flex px-20 pb-16 pt-8">
      <div className="flex min-w-0 flex-1 flex-col gap-8">
        {selectedShowcase && (
          <SelectedShowcase selectedShowcase={selectedShowcase} />
        )}
      </div>
      <VerticalShowcaseList
        list={list}
        selectedShowcase={selectedShowcase}
        onClickShowcase={setSelectedShowcase}
      />
    </section>
  );
}

export function HomeShowcases() {
  return (
    <Suspense
      fallback={
        <div className="flex gap-16 px-20 pb-16 pt-8">
          <div className="aspect-1 flex-1 rounded-16 skeleton" />
          <div className="flex basis-[60px] flex-col gap-8">
            <div className="size-[60px] rounded-16 bg-gray-300 skeleton" />
            <div className="size-[60px] rounded-16 bg-gray-300 skeleton" />
            <div className="size-[60px] rounded-16 bg-gray-300 skeleton" />
          </div>
        </div>
      }
    >
      <HomeShowcaseList />
    </Suspense>
  );
}
